"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgHdmi(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M5 14a2 2 0 00-2 2v4.276a2 2 0 00.464 1.28L7.4 26.28a2 2 0 001.537.72h22.126a2 2 0 001.537-.72l3.936-4.724a2 2 0 00.464-1.28V16a2 2 0 00-2-2H5z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M12 20.5h16", stroke: "currentColor", strokeWidth: 4, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgHdmi;
//# sourceMappingURL=Hdmi.js.map